<template>
  <Modal v-model="billPaymentModal" :title="$t('key1003590')" :transfer="false" :mask-closable="false"
    @on-visible-change="auditConfirmationChange">
    <Form ref="billPaymentForm" :model="billPaymentForm" :label-width="90" :rules="ruleValidate" @submit.native.prevent>
      <Row>
        <p class="mb10">{{ $t('key1003592') }}</p>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="setingTalg">
          <Form-item :label="$t('key1003591')" prop="password">
            <Input v-model="billPaymentForm.password" :placeholder="$t('key1003589')"
              type="password" password style="width: 80%;"></Input>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="billPaymentModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="handlerBillPayment">{{ $t('key1002041') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';

export default {
  name: "billPaymentModal",
  mixins: [Mixin],
  props: {
    selectTableData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    ymsBillId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      billPaymentModal: false,
      billPaymentForm: {
        password: ''
      },
      ruleValidate: {
        password: [
          {
            required: true,
            message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003589'),
            trigger: 'blur'
          }
        ]
      },
      setingTalg: false,
    };
  },
  methods: {
    // 先查询是否设置了打款密码
    getSetPassword() {
      let v = this;
      if (v.getPermission('erpCommonSettingParam_queryPaymentPassword')) {
        v.setingTalg = false;
        return new Promise((resolve) => {
          v.axios.get(api.get_erpCommonSettingParam_queryPaymentPassword).then(response => {
            if (response.data.code === 0) {
              let data = response.data.datas;
              if (data && data.length > 0) {
                data.map((item) => {
                  if (item.paramKey == 'paymentPassword') {
                    if (item.paramValue) {
                      v.setingTalg = true;
                    }
                  }
                });
              }
              resolve(v.setingTalg);
            }
          });
        });
      } else {
        v.gotoError();
      }
    },
    // 处理确认打款
    handlerBillPayment() {
      let v = this;
      let query = {};
      if (v.selectTableData.length > 0) {
        query.paymentPassword = v.billPaymentForm.password;
        query.ymsBillIds = v.selectTableData;
      } else {
        query = {
          paymentPassword: v.billPaymentForm.password,
          ymsBillIds: [v.ymsBillId]
        };
      }
      v.$refs['billPaymentForm'].validate((valid) => {
        if (valid) {
          v.axios.post(api.post_ymsSupplierBill_updateBillPayment, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
              v.billPaymentModal = false;
              v.$emit('updateData', true);
            }
          });
        }
      });
    },
    // 监听弹窗
    auditConfirmationChange(value) {
      if (!value) {
        this.$refs['billPaymentForm'].resetFields();
      }
      this.$emit('auditConfirmationChange', value);
    },
  }
};
</script>

<style scoped>

</style>